export const Route ={
    Home : `${process.env.PUBLIC_URL || `/`}`,
    Messenger : `${process.env.PUBLIC_URL}/messenger`,
    RightSidebar : `${process.env.PUBLIC_URL}/blog/right-sidebar`,
    LeftSidebar : `${process.env.PUBLIC_URL}/blog/left-sidebar`,
    SidebarDetails : `${process.env.PUBLIC_URL}/blog/sidebar-details`,
    NoSidebar : `${process.env.PUBLIC_URL}/blog/no-sidebar`,
    Login : `${process.env.PUBLIC_URL}/auth/login`,
    SignInClassic : `${process.env.PUBLIC_URL}/auth/sign-in-classic`,
    SignUp : `${process.env.PUBLIC_URL}/auth/sign-up`,
    SignUpClassic : `${process.env.PUBLIC_URL}/auth/sign-up-classic`,
    ForgetPassword : `${process.env.PUBLIC_URL}/auth/forget-password`,
    About : `${process.env.PUBLIC_URL}/bonus/about`,
    Faq : `${process.env.PUBLIC_URL}/bonus/faq`,
    Elements : `${process.env.PUBLIC_URL}/bonus/elements`,
}